enum MediaQuery {
  PC = 'PC',
  Tablet = 'Tablet',
  Mobile = 'Mobile',
}

export default MediaQuery
